@import "~@govbr-ds/core/src/components/pagination/pagination";
@import "~@govbr-ds/core/src/components/divider/divider";

:host {
  display: block;

  /* Regra: até 4 itens no dropdown de reticências não deve haver rolagem; a partir de 5, deve. */
  /* O core aplica scroll sempre em .pagination-ellipsis .br-list; sobrescrevemos aqui. */
  .pagination-ellipsis br-list {
    max-height: none;
    overflow: visible;
  }

  .pagination-ellipsis br-list.has-scroll {
    max-height: 220px; /* mantém o valor do core */
    overflow-y: auto;

    @include scrollbar; /* aplica o estilo da barra de rolagem do DS */
  }

  .br-pagination button.page:not(.active) {
    background-color: transparent;
  }
}

:host([variant="contextual"]) .br-pagination {
  justify-content: space-between;
}

:host(:not([variant="contextual"])) .br-pagination {
  justify-content: center;
}

:host([variant="contextual"]) .br-pagination ul {
  justify-content: center;
  width: 100%;
}

:host([color-mode="dark"]) br-select {
  --color: var(--color-dark);
  --focus-color: var(--focus-color-dark);
}

:host([color-mode="dark"]) br-select::part(label) {
  color: var(--color-dark);
}

:host([color-mode="dark"]) .br-pagination a.page:not(.active),
:host([color-mode="dark"]) .br-pagination button.page:not(.active) {
  color: var(--color);
  background-color: transparent;
  border-color: transparent;
}

.br-pagination.dark-mode .br-select .br-item label,
.br-pagination.dark-mode .page {
  color: var(--color-dark);
  background-color: transparent;
}

:host([color-mode="dark"]) .br-pagination a.page:not(.active):hover,
:host([color-mode="dark"]) .br-pagination a.page:not(.active):focus,
:host([color-mode="dark"]) .br-pagination a.page:not(.active):focus-visible,
:host([color-mode="dark"]) .br-pagination button.page:not(.active):hover,
:host([color-mode="dark"]) .br-pagination button.page:not(.active):focus,
:host([color-mode="dark"]) .br-pagination button.page:not(.active):focus-visible {
  color: var(--interactive);
}

/* Realce de foco visível nos identificadores (botões) de página */
.br-pagination .page:focus-visible {
  outline: var(--focus) var(--focus-style) var(--focus-width);
  outline-offset: var(--focus-offset);
}

.pagination-ellipsis br-button::part(button) {
  --button-size: var(--pagination-size);
}

.pagination-ellipsis br-button:focus-visible {
  outline: var(--focus) var(--focus-style) var(--focus-width);
  outline-offset: var(--focus-offset);
  border-radius: 50%;
}

/* Utilitário para conteúdo apenas para leitores de tela */
.visually-hidden {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap; /* impede quebra de linha */
}

:host([color-mode="dark"]) br-select::part(radio-label) {
  color: var(--color-dark);
}
